
mainApp.component('vsocketAssign', {
	templateUrl: '/public/components/vsocket-assign.component.html',
	bindings: {
		socketSettings: '=',
		secondarySocketSettings: '=',
		siteId: '<',
		disableButton: '<',
	},
	controller: vsocketAssignController
});


function vsocketAssignController($rootScope, $scope) {

	let ctrl = this;
	let GLOBAL_VSOCKET_ASSIGN_ERROR_MSG = 'Could not add another vSocket socket';

	let assignSettings = {
		'AWS' : {
			path: '/createAwsvSocket',
			params: {eniIpAddress: null, eniIpSubnet: null, routeTableId: null}
		},
		'AZURE' : {
			path: '/createAzurevSocket',
			params: {interfaceIp: null, floatingIp: null}
		}
	}

	ctrl.$onInit = () => {
		resetAssignSettings();
	}

	/**
	 * On change between site to site update the following:
	 * 1. Change the param object that will be sent to create the socket, depending on the site conn type
	 */
	ctrl.$onChanges = () => {
		resetAssignSettings();
	}

	/**
	 * 1. Check that the primary socket is registered
	 * 2. Check if LAN AND HA destType is supported -> meaning vSocket HA is supported
	 * 3. Make sure the site is not already in HA mode
	 */
	ctrl.shouldShowAssignButton = () => {
		return isPrimarySocketAssigned() && isLanAndHaSupported() && !ctrl.isSiteHa;
	}

	let isLanAndHaSupported = () => {
		let lanSocketInterface = getLanInterface();
		return lanSocketInterface?.metadata?.supportedDestinations?.some(dest => dest.value === 'LAN_AND_HA');
	}

	let getLanInterface = () => {
		return ctrl.socketSettings?.links.filter(si => si.destType?.value === 'LAN')[0];
	}

	let isPrimarySocketAssigned = () => {
		let registrationStatus = ctrl.socketSettings?.registrationStatus;
		return registrationStatus === 'REGISTERED' || registrationStatus === 'ASSIGNED_SITE';
	}

	let resetAssignSettings = () => {
		ctrl.currAssignSettings = assignSettings[ctrl.socketSettings.type.value];
		if (ctrl.currAssignSettings != null){
			Object.keys(ctrl.currAssignSettings.params).forEach(field => ctrl.currAssignSettings.params[field] = null);
		}
	}

	ctrl.onClick = () => {
		$rootScope.openPopup('addSecondaryVSocket');
	};

	ctrl.closeAddSocket = () => {
		$rootScope.clearErrors();
		$rootScope.closePopup('addSecondaryVSocket');
	};

	ctrl.createSecondaryHaVirtualSocket = () => {

		$rootScope.clearErrors();

		store.save({
			path: ctrl.currAssignSettings.path,
			method: 'POST',
			queryParams: { siteId: ctrl.siteId, accountId: $rootScope.accountId },
			data: ctrl.currAssignSettings.params,
			success: (data) => {
				handleAssignResponses(data);
				$scope.$digest();
			},
			error: (error) => {
				$rootScope.errors['global'] = GLOBAL_VSOCKET_ASSIGN_ERROR_MSG;
			}
		});
	};

	const handleAssignResponses = (data) => {
		if(data && data.status && data.status == "ERROR"){
			handleResponseErrors(data);
		}
		else{
			handleResponseSuccess(data);
		}
	}

	/**
	 * There might be both errors that need to be shown on the pop up, and  errors that need to be shown globally
	 */
	let handleResponseErrors = (data) => {
		handlePopupErrors(data);
		handleGlobalErrors(data);
	}

	/**
	 * handle error messages that need to be shown in the popup
	 */
	let handlePopupErrors = (data) => {
		data.notifications.forEach(error => {
			$rootScope.errors[error.field] = error.message;
		})
	}

	/**
	 * handle error messages that are not shown in the popup
	 */
	let handleGlobalErrors = (data) => {
		let globalErrors = data.notifications.filter(error => !errorsThatShouldShowInPopUp(error));
		if (globalErrors.length > 0){
			$rootScope.showNotification('error', globalErrors.pop().message, 'error', true);
		}
	}

	/**
	 * Returns if an error message needs to be shown in the popup
	 */
	let errorsThatShouldShowInPopUp = (error) => {
		let partialPopupErrorPaths = ['subnet', 'routeTableID', 'managementIP-secondary', 'floating'];
		return partialPopupErrorPaths.some(path => error.field.includes(path));
	}

	let handleResponseSuccess = (data) => {
		let args = {};
		// broadcast an event so the sitesCtrl could reload
		$rootScope.$broadcast('unassignSocketOrSocketAdditionEvent', args);
		resetAssignSettings();
		ctrl.closeAddSocket();
	}

    ctrl.isSocketType = (type) => {
        return ctrl.socketSettings.type.value === type;
    }

}
